import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { asyncRegisterUser } from '../states/users/action';
import { useInput } from '../hooks/useInput';
import CustomInput from '../components/utilities/CustomInput';
import CustomLabel from '../components/utilities/CustomLabel';
import Button from '../components/utilities/Button';
import EyeSlashIcon from '../components/icons/EyeSlashIcon';
import EyeIcon from '../components/icons/EyeIcon';

export default function RegisterPage() {
  const dispatch = useDispatch();
  const [name, setName] = useInput('');
  const [email, setEmail] = useInput('');
  const [password, setPassword] = useInput('');
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const onSubmitEventHandler = async (event) => {
    event.preventDefault();
    const isSuccess = await dispatch(
      asyncRegisterUser({ name, email, password })
    );
    if (isSuccess) navigate('/login');
  };

  const onShowPasswordHandler = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <section>
      <h1 className="text-center text-2xl font-bold mb-8">
        Create new account
      </h1>
      <div className="w-full m-auto rounded-lg py-7 px-8 flex flex-col gap-x-2 sm:w-96 sm:shadow sm:border sm:border-zinc-200 dark:sm:border-zinc-900">
        <form className="flex flex-col gap-y-6" onSubmit={onSubmitEventHandler}>
          <div className="flex flex-col">
            <CustomLabel htmlFor="name">
              <p>Name</p>
              <CustomInput
                type="text"
                id="name"
                value={name}
                onChange={setName}
              />
            </CustomLabel>
          </div>
          <div className="flex flex-col">
            <CustomLabel htmlFor="email">
              <p>Email</p>
              <CustomInput
                type="email"
                id="email"
                value={email}
                onChange={setEmail}
              />
            </CustomLabel>
          </div>
          <div className="flex flex-col">
            <CustomLabel htmlFor="password">
              <p>Password</p>
              <div className="relative">
                <CustomInput
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  value={password}
                  onChange={setPassword}
                />
                <button
                  className="absolute top-1/2 -translate-y-1/2 right-2"
                  onClick={onShowPasswordHandler}
                  type="button">
                  {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
                </button>
              </div>
            </CustomLabel>
          </div>
          <Button label="Register" isSubmit />
        </form>
      </div>
      <p className="mt-8 text-center">
        Already have an account?
        <Link
          to="/login"
          className="ml-2 text-cyan-500 dark:text-cyan-700 hover:text-cyan-600 dark:hover:text-cyan-600 hover:underline">
          Login here
        </Link>
      </p>
    </section>
  );
}
